/* global document */

// Lib
import { useEffect, useCallback, useRef } from 'react';

const useClickOutside = (onClickOutside: VoidFunction) => {
  const node: any = useRef();

  const handleClick = useCallback(
    (event: Event) => {
      if (node.current.contains(event.target)) return;

      onClickOutside();
    },
    [onClickOutside]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick]);

  return { node };
};

export default useClickOutside;
